export default __webpack_public_path__ + "static/corp-sponsor-logos-5d08d89ac3ee3799ec84231482cecd19.jpg";